<div class="container-fluid">
  <div class="row ">
    
 
    <div class="col-10 mt-4">
      <h5> <b> Personal details </b> </h5>
      <p style="color: #6D6D6D;"> Update Your Personal Information</p>
      <div class="row">
        <div class="col-10 d-flex justify-content-between  align-items-center text-center user-img">
          <span> <img [src]=" profileImage" class="rounded-circle"
              style="width: 128px; height: 128px;"></span>

          <p class="text-color" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight"> Edit</p>

        </div>
      </div>
      <div class="row">
        <div class="col-10  justify-content-between align-items-center text-center d-flex name-edit">
          <span class="d-flex gap-2" style="
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap"> 
            <p style="color: #6D6D6D;"> Name </p>
            <b style="
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap"> {{username}} {{lastname}}</b> <b> </b>
          </span>
          <p class="text-color" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight12"
            aria-controls="offcanvasRight" class="pointer" style="color: #309EAE;"> Edit</p>
        </div>
      </div>
      <div class="row">
        <div class="col-10  justify-content-between align-items-center text-center d-flex name-edit">
          <span class="d-flex gap-2" style="
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap">
            <p style="color: #6D6D6D;">Display Name</p>
            <p style=" 
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap"><b>{{displayNameu}}</b>   </p>
          </span>
          <p class="text-color" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight1234" aria-controls="offcanvasRight"> Edit</p>
        </div>
      </div>
      <div class="row">
        <div class="col-10  justify-content-between align-items-center text-center d-flex name-edit">
          <span class="d-flex gap-2">
            <p style="color: #6D6D6D;"> Email address </p>
            <b>{{usermail}}</b>
          </span>
          <!-- <p class="text-color " data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight123"
  aria-controls="offcanvasRight"> Edit</p> -->
        </div>
      </div>

    </div>
  </div>
</div>




<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title" id="offcanvasRightLabel">Edit profile photo </h5>
    <button  #closeBtn type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"(click)="back();"></button>
  </div>
  <div class="offcanvas-body d-flex flex-column justify-content-between">
    <div class="d-flex justify-content-center align-items-center">
      <img *ngIf="remove" class="   user-imges" src="{{user.profilePhotoUrl}}" 
        style="width: 200px; height: 200px;">

      <img *ngIf="errorimg && !selectedFile" class="user-imges" src="assets/settingIcon/errorimg.png" 
        style="width: 200px; height: 200px;">
         <img *ngIf="selectedFile && profile" class="   user-imges" src="{{user.profilePhotoUrl  }}" alt="User Icon"
        style="width: 200px; height: 200px;">
    </div>
    <div *ngIf="removebtn" class=" align-items-center text-center romove">
      <span class="pointer"><b (click)="removeimg()"> Remove</b> </span>


    </div>
    <input type="file" #fileInput accept="image/*" (change)="oonFileSelected($event)" style="display: none;" />
 

 <div *ngIf="addimage" id="add-pfofile" (click)="updateprofile();fileInput.click()">  <span class="pointer"><b >Add profile photo</b> </span></div>  

    <div *ngIf="update"  id="update-profile" (click)="successimgupload()">    <span class="pointer" ><b >Update</b> </span></div>


    <div *ngIf="successimg" class="d-flex flex-column justify-content-center align-items-center min-vh-100">
      <img src="assets/settingIcon/image.png" alt="Success" style="max-width: 200px;" />
      <b class="mt-3"> Profile photo updated</b>
    </div>


  </div>

</div>






<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight12" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title" id="offcanvasRightLabel12"> Edit profile name </h5>
    <button #closeBtn2 type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="backs()"></button>
  </div>
  <div class="offcanvas-body d-flex flex-column justify-content-between">



    <form *ngIf="!updatemsg">
      <div class="mb-3">
        <label for="exampleInputEmail1" class="form-label">First Name</label>
        <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="{{username}}"  name="firstName" [(ngModel)]="user.firstName" >

      </div>
      <div class="mb-3">
        <label for="exampleInputPassword1" class="form-label">Last Name</label>
        <input type="text" class="form-control" id="exampleInputPassword1" placeholder="{{lastname}}" name="lasttName" [(ngModel)]="user.lastName" >
      </div>

    </form>
    <div class="align-items-center text-center">
      <p *ngIf="!updatemsg" id="update-profile" (click)="updatenameapi()" class="pointer"> Update </p>
    </div>
  </div>
  <div *ngIf="showimgsuccess" class="d-flex flex-column justify-content-center align-items-center min-vh-100">
    <img src="assets/settingIcon/image.png" alt="Success" style="max-width: 200px;" />
    <b class="mt-3"> Profile name updated</b>
  </div>

</div>










<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight123" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header border-bottom">
    <h5 *ngIf="!editemail" class="offcanvas-title" id="offcanvasRightLabel"> Edit email</h5>
    <h5 *ngIf="editemail" class="offcanvas-title" id="offcanvasRightLabel"> Verify email address</h5>
    <button #closeBtn3 type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="backemail()"></button>
  </div>
  <div class="offcanvas-body d-flex flex-column justify-content-between ">
    
    <form *ngIf="editemail">
  <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">Email </label>
    <input type="email"
         class="form-control"
         name="email"
         placeholder="{{usermail}}"
         [(ngModel)]="emails.email"
         #emailRef="ngModel"
         required
       pattern=".+@.+\.com$"   (ngModelChange)="onEmailChange()" />
  <P style="color: red;">{{emailerrormsg}} </P>
<P style="color: red;">{{fillerror}} </P>
   <span *ngIf="emailRef.errors?.['pattern']" style="color: red;">Plese Enter Valid Email</span>
  </div>
  
  
</form>
<div> 
<p *ngIf="confirm && emails.email" style="color: #6D6D6D;"> We have send the code to the email address below verify your account by tyoing 6 digit code</p>
<div  *ngIf="confirm" class="d-flex justify-content-between" style="color: #309EAE;"> 
  <p> {{emails.email}}</p>
  <P (click)="backemail()"> Edit</P>
  
  
</div>
<div   class="otp">
<ng-otp-input *ngIf="confirm"
              [config]="otpConfig"
              [ngModel]="otpValue"
              
              (onInputChange)="onOtpChange($event)">
             
</ng-otp-input>
<p style="color: red;"> {{otpemailerrormsg}} </p>

<p  *ngIf="confirm && !showResendButton " ><b >Resend Code In </b>  <b  class="pointer" style="color: #309EAE;"> {{ resendTimer }} Second </b></p>
<b  class="pointer" (click)="resendotp()" style="color:#309EAE"  *ngIf="showResendButton"> Send OTP</b>

</div>

</div>
 <div class="align-items-center text-center">
      <p *ngIf="editemail"  id="update-profile" (click)="emailverify()" class="pointer"> Update </p>
      <p *ngIf="confirm"  id="update-profile" (click)="showsuccesss()" class="pointer"> Confirm </p>
    </div>

    <div *ngIf="imgshow" class="d-flex flex-column justify-content-center align-items-center min-vh-100">
      <img src="assets/settingIcon/image.png" alt="Success" style="max-width: 200px;" />
      <b class="mt-3">Email address verified</b>
      <p> Your email address has been updated.  </p>
      <p style="color: #286676;"> {{usermail}}</p>
    </div>
  </div>
</div>









    

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight1234" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header  border-bottom">
    <h5 class="offcanvas-title" id="offcanvasRightLabel">Edit display name</h5>
    <button #closeBtn4 type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="backdisupdate()"></button>
  </div>
  <div class="offcanvas-body d-flex flex-column justify-content-between">
    
    <form *ngIf="!updatedisplayname" >
      <div class="mb-3">
        <label for="text" class="form-label">Display name</label>
        <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="{{displayNameu}}" name="displayName"[(ngModel)]="user.displayName">

</div>
</form>
<div *ngIf="!updatedisplayname " class="align-items-center text-center">
  <p   id="update-profile" (click)="displaynamesupdate()" class="pointer"> Update </p>
 
</div>
<div *ngIf="updatedisplayname" class="d-flex flex-column justify-content-center align-items-center min-vh-100">
  <img src="assets/settingIcon/image.png" alt="Success" style="max-width: 200px;" />
  <p><b> Display name updated</b>   </p>
  </div>
</div>



<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasRightLabel">Offcanvas right</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    
  </div>
</div>